// Fiyat formatla (örn: 29.99)
export const formatPrice = (price) => {
  if (price === undefined || price === null) return '0.00';
  
  return parseFloat(price).toFixed(2);
};

// Para birimi formatla (örn: 29.99 TL)
export const formatCurrency = (amount, currency = 'TL', decimals = 2) => {
  if (amount === undefined || amount === null) {
    if (decimals === 0) return `0 ${currency}`;
    return `0.${'0'.repeat(decimals)} ${currency}`;
  }
  
  return `${parseFloat(amount).toFixed(decimals)} ${currency}`;
};

// Telefon numarası formatla (örn: (555) 123 45 67)
export const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return '';
  
  // Sadece sayıları al
  const numbers = phoneNumber.replace(/\D/g, '');
  
  if (numbers.length === 10) {
    return `(${numbers.substring(0, 3)}) ${numbers.substring(3, 6)} ${numbers.substring(6, 8)} ${numbers.substring(8, 10)}`;
  } else if (numbers.length === 11 && numbers.startsWith('0')) {
    return `(${numbers.substring(1, 4)}) ${numbers.substring(4, 7)} ${numbers.substring(7, 9)} ${numbers.substring(9, 11)}`;
  }
  
  return phoneNumber;
};

// TC Kimlik Numarası formatla (maskelenmiş)
export const formatTCID = (tcId) => {
  if (!tcId) return '';
  
  // İlk 2 ve son 2 rakamı göster, arasını maskele
  return tcId.length === 11
    ? `${tcId.substring(0, 2)}*****${tcId.substring(9, 11)}`
    : tcId;
};

// Adres kısaltma (çok uzun adresler için)
export const truncateAddress = (address, maxLength = 50) => {
  if (!address) return '';
  
  if (address.length <= maxLength) return address;
  
  return address.substring(0, maxLength) + '...';
};

// Boyut formatla (KB, MB, GB)
export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Byte';
  
  const k = 1024;
  const sizes = ['Byte', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

// İsim formatla (ilk harfleri büyük)
export const formatName = (name) => {
  if (!name) return '';
  
  return name
    .split(' ')
    .map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');
};
